<template>
	<div class="search-options">
		<Label
			v-if="label"
			:for="uid"
			class="search-options__label"
			:labelText="label"
		/>
		<div class="search-options__search" :style="widthStyle">
			<DropdownV2
				v-model="value.searchType"
				@change="handleChangeEventSearchType"
				:defaultValue="searchTypeDefaultValue"
				:options="searchTypeOptions"
			/>
			<Search
				v-model="value.search"
				:placeholder="placeholderFromSearchType"
				@change="handleChangeEventSearch"
				@autosuggest-selection="handleAutosuggestSelection"
				@autosuggest-hidden="$emit('autosuggest-hidden')"
				@autosuggest-visible="$emit('autosuggest-visible')"
				:autosuggestOptions="autosuggestOptions"
				:timeout="timeout"
				:autosuggest="autosuggest"
				:autosuggestHideGroupsLabel="autosuggestHideGroupsLabel"
				ref="searchWithAutosuggestRef"
			/>
		</div>
	</div>
</template>

<script>
import DropdownV2 from '@/components/forms/dropdown/dropdown-v2.vue';
import Label from '@/components/forms/label/label';
import Search from '@/components/forms/search/search.vue';

export default {
	name: 'SearchOptions',
	components: {
		Search,
		Label,
		DropdownV2
	},
	props: {
		label: {
			type: String,
			default: ''
		},
		value: {
			type: Object,
			default: () => {}
		},
		searchTypeDefaultValue: {
			type: [String, Boolean, Number],
			required: true
		},
		searchTypeOptions: {
			required: true,
			type: Array,
			default: () => [],
			validator: options => {
				return options.every(
					option =>
						typeof option === 'object' &&
						'text' in option &&
						'value' in option
				);
			}
		},
		autosuggestOptions: {
			type: Array,
			default: () => []
		},
		timeout: {
			type: Number,
			default: 0
		},
		autosuggest: {
			type: Boolean
		},
		autosuggestHideGroupsLabel: Boolean,
		width: {
			type: String,
			default: ''
		}
	},
	computed: {
		placeholderFromSearchType() {
			return (
				this.searchTypeOptions.find(
					type => type.value == this.value.searchType
				).placeholder || ''
			);
		},
		widthStyle() {
			if (typeof this.width === 'number') {
				return {
					width: `${this.width}px`
				};
			} else {
				return {
					width: this.width
				};
			}
		}
	},
	methods: {
		visible() {
			this.$refs.searchWithAutosuggestRef.visible();
		},
		hide() {
			this.$refs.searchWithAutosuggestRef.hide();
		},
		clearOn() {
			this.$refs.searchWithAutosuggestRef.clearOn();
		},
		clearOff() {
			this.$refs.searchWithAutosuggestRef.clearOff();
		},
		handleChangeEventSearch(search) {
			const objToEmit = {
				searchType: this.value.searchType,
				search: search
			};

			this.$emit('input', objToEmit);
			this.$emit('change', objToEmit);
		},
		handleChangeEventSearchType(searchType) {
			const objToEmit = {
				searchType: searchType,
				search: this.value.search
			};

			this.$emit('input', objToEmit);
			this.$emit('change', objToEmit);
		},
		handleAutosuggestSelection(e) {
			this.$emit('autosuggest-selection', e);
		}
	}
};
</script>

<style lang="scss">
/**
    * Search Options styles
    * Can use SCSS variables = TRUE
*/

.search-options__search {
	display: grid;
	grid-template-columns: auto 1fr;

	.dropdown {
		width: initial;
	}

	.dropdown__input-container {
		border-right: 0;
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
	}

	.search__input-container {
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
	}
}
</style>
